import React from 'react'

/**
 * LegendNoneIcon - circle with a slash to indicate no legend
 */
export const LegendNoneIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Legend Off" {...props}>
    <circle cx="12" cy="12" r="8" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <line x1="7" y1="17" x2="17" y2="7" stroke="currentColor" strokeWidth="1.5" />
  </svg>
)

export default LegendNoneIcon

